import asyncResource from 'ContentData/reducers/helpers/asyncResource';
export default asyncResource;